import { useState, useEffect } from "react";
import { Marker, Source, Layer } from "react-map-gl";
import Pin from "./pin";
import httpClient from "../../lib/httpClient";

const AgriPartitasRenderer = ({
  policyNumber,
  setCurrentLongitude,
  setCurrentLatitude,
  setZoomLevel,
  currentlyVisiblePartitas,
}) => {
  // eslint-disable-next-line no-unused-vars
  const [geoJsonValue, setGeoJsonValue] = useState({});
  const [geoJsonParitasValueMap, setGeoJsonParitasValueMap] = useState([]);

  useEffect(() => {
    if (policyNumber) {
      httpClient()
        .get(`/agriculturePolicies/${policyNumber}/geometry`)
        .then((res) => res.data)
        .then(async (data) => {
          if (!data.policyGeo || data.policyGeo.length === 0) {
            console.log("No location data found for policy", policyNumber);
          } else if (data.policyGeo[0].centerLon) {
            setCurrentLongitude(data.policyGeo[0].centerLon);
            setCurrentLatitude(data.policyGeo[0].centerLat);
            setZoomLevel(data.policyGeo[0].zoomLevel);
            // make geojson object from string
            const geojsonAsObject = JSON.parse(data.policyGeo[0].geojson);
            setGeoJsonValue(geojsonAsObject); // We have not decided yet if we will use this
          }

          data.cadastralRecordsGeo.forEach((element) => {
            element.geojsonAsObject = JSON.parse(element.geojson);
          });
          setGeoJsonParitasValueMap(data.cadastralRecordsGeo);
        });
    }
  }, [policyNumber, setCurrentLongitude, setCurrentLatitude, setZoomLevel]);

  const renderOneMarker = (lat, lon, cadastralRecord) => (
    <Marker key={cadastralRecord} longitude={lon} latitude={lat}>
      <Pin size={8} />
      {"Pt " + cadastralRecord}
    </Marker>
  );

  const renderOneGeoJson = (geoJsonValue, uniqId) => {
    const sourceId = `polygons-${uniqId}`;
    const layerId = `layer-${uniqId}`;
    const layerTextId = `layer-text-${uniqId}`;
    // Note: key= is needed because it is an array
    // Note: uniqId is needed because we have multiple Source's in the same map
    return (
      <Source id={sourceId} type="geojson" data={geoJsonValue} key={sourceId}>
        <Layer
          id={layerId}
          type="fill"
          source={sourceId}
          paint={{
            "fill-color": "#2296F3",
            "fill-opacity": 0.2,
            "fill-outline-color": "#FF00FF",
          }}
        />
        <Layer
          id={layerTextId}
          type="symbol"
          source={sourceId}
          layout={{
            "text-field": ["get", "Mappale"],
            "text-size": 12,
          }}
        />
      </Source>
    );
  };

  const layersForAllCurrentlyVisiblePartitas = geoJsonParitasValueMap
    .filter((element) => currentlyVisiblePartitas[element.cadastralRecord])
    .map((element) => renderOneGeoJson(element.geojsonAsObject, element.cadastralRecord));

  const markersForAllPartitas = geoJsonParitasValueMap.map((element) =>
    renderOneMarker(element.centerLat, element.centerLon, element.cadastralRecord),
  );

  return (
    <>
      {layersForAllCurrentlyVisiblePartitas}
      {markersForAllPartitas}
    </>
  );
};

export default AgriPartitasRenderer;
